import React from "react";

import { Button, Grid, Typography } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import { useTranslation } from "react-i18next";

import useStyles from "../Maintenance/Maintenance.styles.js";

function ErrorComponent() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid className={classes.swrContainer}>
      <Grid className={classes.swrWrapper}>
        <Typography marginTop="1rem" variant="h6" textAlign="center">
          {t("COMMON.SOMETHING_WENT_WRONG_PLEASE_RELOAD")}
        </Typography>
        <div className={classes.maintenanceImgWrapper}>
          <img alt="" src="/images/maintenance.svg" />
        </div>
        <Typography variant="h6" textAlign="center" marginTop="2rem">
          <Button
            onClick={() => {
              window.location.reload();
            }}
            className={classes.btnPrimary}
          >
            {" "}
            {t("COMMON.RELOAD")}
            <ReplayIcon />
          </Button>
        </Typography>
      </Grid>
    </Grid>
  );
}

export default ErrorComponent;
